import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'VITE_SUPABASE_URL ve VITE_SUPABASE_ANON_KEY tanimli olmali. .env dosyasini kontrol edin.'
  );
}

// NOT: createClient generic tipi kullanılmıyor — supabase gen types üretilene
// kadar (Sprint 8) Database tipi placeholder. Komponentlerdeki tipler manuel.
export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export const ALLOWED_EMAIL = import.meta.env.VITE_ALLOWED_EMAIL ?? '';
